import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface AppState {
  appVersion?: string;
  setAppVersion: (version: string) => void;
}

export const useAppStore = create<AppState>()(
  persist(
    (set) => ({
      appVersion: undefined,
      setAppVersion: (version: string) => set({ appVersion: version }),
    }),
    {
      name: 'hanly-app-settings',
      partialize: (state) => ({ appVersion: state.appVersion }),
    },
  ),
);
